module.exports = __webpack_public_path__ + "static/media/adults-beverages.651a0fdc.jpg";